import { Result } from "antd-mobile";

const NotFoundPage : React.FC = () => {
    return (
        <Result
            status={"warning"}
            title={"不允许访问"}
        />
    );
};


export default NotFoundPage;